import CommentsContainer from './Comments.container';
import Comments from './Comments';
export default CommentsContainer(Comments);
//# sourceMappingURL=index.js.map